
// Komponenten <responsive-container>,
// direktivet  v-responsive-container och
// mixinen ResponsiveContainerMixin.
//
// Detta är en klon av "vue-responsive-components", // https://github.com/Kelin2025/vue-responsive-components, med ändrade namn och ökat throttleintervall (minskad tid). Den hanterar "container queries" för ett container-element och kan användas på tre sätt, som:
//
// - ResponsiveContainer component with scoped slot:
//
//			<template>
//			  <responsive-container :breakpoints="{
//				 small: el => el.width <= 500
//			  }">
//				 <div slot-scope="el" :class="['post__item', { small: el.is.small }]">
//					<img class="post__image" :src="post.image" />
//					<div class="post__text">{{post.text}}</div>
//				 </div>
//			  </responsive-container>
//			</template>

//			<script>
//			import { ResponsiveContainer } from "ResponsiveContainer"

//			export default {
//			  props: ["post"],
//			  components: { ResponsiveContainer }
//			}
//			</script>
//
// - v-responsive directive:
//
//			<template>
//			  <!-- Will add/remove .small if the width is less / greater -->
//			  <div class="post__item" v-responsive="{ small: el => el.width <= 500 }">
//				 <img class="post__image" :src="post.image" />
//				 <div class="post__text">{{post.text}}</div>
//			  </div>
//			</template>

//			<script>
//			import { ResponsiveContainerDirective } from "ResponsiveContainer"

//			export default {
//			  props: ["post"],
//			  directives: {
//				 responsive: ResponsiveContainerDirective
//			  }
//			}
//			</script>
//
// - Mixin:
//
//			<template>
//			  <div :class="['post__item', { small: el.is.small }]">
//				 <img class="post__image" :src="post.image" />
//				 <div class="post__text">{{post.text}}</div>
//			  </div>
//			</template>

//			<script>
//			import { ResponsiveContainerMixin } from "ResponsiveContainer"

//			export default {
//			  props: ["post"],
//			  mixins: [ResponsiveContainerMixin],
//			  breakpoints: {
//				 small: el => el.width <= 500
//			  }
//			}
//			</script>


import throttla from 'lodash.throttle';
import ResizeObserver from 'resize-observer-polyfill';


//################################################################################################

export const ResponsiveContainerMixin = {
	data() {
		return {
			el: {
				width: 0,
				height: 0,
				is: {}
			}
		}
	},

	mounted() {
		if (
			typeof process === 'undefined' ||
			(!process.server && (this.breakpoints || this.$options.breakpoints))
		) {
			this.$nextTick(() => {
				const handleResize = throttla(entries => {
					const cr = entries[0].contentRect
						; (this.el.width = cr.width), (this.el.height = cr.height)
					const conds = Object.assign(
						{},
						this.breakpoints || {},
						this.$options.breakpoints || {}
					)
					for (const breakpoint in conds) {
						this.$set(this.el.is, breakpoint, conds[breakpoint](this.el))
					}
				}, 100);		// ############# Sänkt från 200 för att förbättra ev tween av browseromdisponerat content. Löset inte problemet helt dock!

				const observer = new ResizeObserver(handleResize)
				if (this.$el instanceof Element) {
					observer.observe(this.$el)
				}
			})
		}
	}
}


//################################################################################################

export const ResponsiveContainer = {
	data() {
		return { init: false }
	},
	props: {
		noHide: { type: Boolean, default: false },
		breakpoints: { type: Object, default: undefined }
	},
	mixins: [ResponsiveContainerMixin],
	render(h) {
		const slot =
			(this.$scopedSlots.default && this.$scopedSlots.default(this.el)) ||
			this.$slots.default

		return !this.noHide && !this.init
			? h(
				'div',
				{
					style: { visibility: 'hidden' }
				},
				[slot]
			)
			: slot
	},
	mounted() {
		this.init = true
	}
}


//################################################################################################

export const ResponsiveContainerDirective = {
	inserted(el, conds) {
		if (typeof process === 'undefined' || !process.server) {
			const handleResize = throttla(entries => {
				const cr = entries[0].contentRect
				for (const breakpoint in conds.value) {
					if (conds.value[breakpoint](cr)) {
						el.classList.add(breakpoint)
					} else {
						el.classList.remove(breakpoint)
					}
				}
			}, 100);		// ############# Sänkt från 200 för att förbättra ev tween av browseromdisponerat content. Löset inte problemet helt dock!

			const observer = new ResizeObserver(handleResize)
			observer.observe(el)
		}
	}
}


//################################################################################################

export const ResponsiveContainerComponentAndDirective = Vue => {
	Vue.component('ResponsiveContainer', ResponsiveContainer)
	Vue.directive('responsive-container', ResponsiveContainerDirective)
}
